import { PostPrivacy } from '@wellesley/openapi'

const getFeedPrivacyDescription = (privacy: PostPrivacy) => {
  switch (privacy) {
    case 'UNLISTED':
      return 'Profile-only visibility, excluded from search'
    case 'DIRECT':
      return 'Mentioned user only'
    case 'PRIVATE':
      return 'Followers only'
    case 'FOLLOW_POST':
      return 'Follow post'
    default:
      return 'Visible to everyone'
  }
}

export default getFeedPrivacyDescription
